import styled from "styled-components";

export const Wrapper = styled.div`
  height: 24px;
  border-top-left-radius: 20px;
  border-bottom-right-radius: 20px;
  position: relative;
  padding-top: 12px;
  padding-bottom: 4px;
`;

export const Handle = styled.div`
  width: 80px;
  height: 4px;
  border-radius: 2px;
  background-color: #e0e0e0;
  margin: auto;
`;


